import {useCallback, useEffect, useState} from "react";
import {getBackendErrorMessage} from "../../shared/utils/httpError";
import {createMetrica, deleteMetrica, getMetrica, getSistema, getVersaoDoPlano, listMetricas, updateMetrica} from "./MetricasService";
import {corpoDaMetrica} from "./metricasRegras";

const valorDe = (response) => response?.data?.valor ?? response?.data ?? null;

const SEM_USO = {sistemas: [], versoes: []};

// Onde a métrica é usada, com o detalhe que o GET dela não traz: a fonte e o "como mede" de cada sistema, e o limite
// de cada versão. Falhar aqui não impede editar: a lista fica sem o detalhe.
const carregarUsos = async (metrica) => {
    const [sistemas, versoes] = await Promise.all([
        Promise.allSettled((metrica.sistemas || []).map((sistema) => getSistema(sistema.id))),
        Promise.allSettled((metrica.versoes || []).map((versao) => getVersaoDoPlano(versao.id_plano, versao.numero))),
    ]);
    return {
        sistemas: (metrica.sistemas || []).map((sistema, i) => {
            const completo = sistemas[i].status === 'fulfilled' ? valorDe(sistemas[i].value) : null;
            return {sistema, apontamento: (completo?.metricas || []).find((item) => item.metrica_id === metrica.id) || null};
        }),
        versoes: (metrica.versoes || []).map((versao, i) => {
            const completa = versoes[i].status === 'fulfilled' ? valorDe(versoes[i].value) : null;
            return {versao, limite: (completa?.limites || []).find((item) => item.id_metrica === metrica.id) || null};
        }),
    };
};

/*
 * Estado e gravações do cadastro de uma métrica (BBF-167 a). `id` "nova" é o cadastro de uma métrica nova.
 * As gravações lançam o erro da API para a página mostrar.
 */
export const useMetrica = (id) => {
    const nova = id === 'nova';
    const [estado, setEstado] = useState({carregando: !nova, erro: '', metrica: null, usos: SEM_USO});

    const carregar = useCallback(async () => {
        if (nova) return null;
        setEstado((atual) => ({...atual, carregando: true, erro: ''}));
        try {
            const metrica = valorDe(await getMetrica(id));
            setEstado((atual) => ({...atual, carregando: false, erro: '', metrica}));
            const usos = await carregarUsos(metrica);
            setEstado((atual) => (atual.metrica?.id === metrica.id ? {...atual, usos} : atual));
            return metrica;
        } catch (error) {
            setEstado({carregando: false, erro: getBackendErrorMessage(error, 'Não foi possível carregar a métrica.'), metrica: null, usos: SEM_USO});
            return null;
        }
    }, [id, nova]);

    useEffect(() => {
        carregar();
    }, [carregar]);

    // Cria e devolve o id da métrica nova, achado pela chave, que é única.
    const criar = useCallback(async (form) => {
        const corpo = corpoDaMetrica(form, true);
        await createMetrica(corpo);
        const achadas = await listMetricas({chave: corpo.chave});
        return achadas.find((item) => item.chave === corpo.chave)?.id || null;
    }, []);

    const salvar = useCallback(async (form) => {
        await updateMetrica(id, corpoDaMetrica(form, false));
        return carregar();
    }, [carregar, id]);

    const excluir = useCallback(() => deleteMetrica(id), [id]);

    return {...estado, nova, recarregar: carregar, criar, salvar, excluir};
};
